"use strict";

require("core-js/modules/es6.object.freeze");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        box-shadow: inset 0 -1px 1px ", ";\n        color: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        background: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var inputStatesCSS = (0, _styledComponents.css)(_templateObject(), function (props) {
  if (props.disabled) {
    return (0, _styledComponents.css)(_templateObject2(), function (props) {
      return props.theme.colors.white['500'];
    });
  }
}, function (props) {
  if (props.isValid === false) {
    return (0, _styledComponents.css)(_templateObject3(), props.theme.colors.red[500], props.theme.colors.red[500]);
  }
});
var _default = inputStatesCSS;
exports["default"] = _default;